import contactRequests from 'app/requests/Contact.requests'
import {
    UseRequestConfig,
} from 'app/types/request.types'

const config: UseRequestConfig = {
    requestFn: (params) => {
        return {
            url: contactRequests.filterRequest().url,
            method: 'POST',
            data: {
                ...params,
            },
        }
    },
}

export default config
